export const PERMANENT_DELETE_AFTER_DAYS = 30; // Number of days after which deleted scans are permanently deleted
